module.exports = __webpack_public_path__ + "img/video.42c4f21.jpg";